export default __webpack_public_path__ + "static/media/office2-afterB-1024w.2647b936.webp";